import { useState } from 'react';
import { apiURL } from '../../consts/URLs';
import { VENDORS } from '../endpointList';
import { fetchRequest, getOptions } from '../utils';
import { getCookie } from '../../utils/handleCookie';
import { cookieName } from '../../consts/cookie';

const token = getCookie(cookieName.token);

export interface VendorPayload {
    name: string;
    code?: string;
    shipping_rule_ids?: number[];
}

const useVendors = () => {
    const [getVendorsResponse, setGetVendorsResponse] = useState<any>();
    const [getVendorsResult, setGetVendorsResult] = useState<any>();

    const [createVendorResponse, setCreateVendorResponse] = useState<any>();
    const [createVendorResult, setCreateVendorResult] = useState<any>();

    const [updateVendorResponse, setUpdateVendorResponse] = useState<any>();
    const [updateVendorResult, setUpdateVendorResult] = useState<any>();

    const [deleteVendorResponse, setDeleteVendorResponse] = useState<any>();
    const [deleteVendorResult, setDeleteVendorResult] = useState<any>();

    const getVendors = () => {
        const url = `${apiURL}/${VENDORS}`;
        const options = getOptions({ method: 'GET', token });
        fetchRequest(url, options, setGetVendorsResponse, setGetVendorsResult);
    };

    const createVendor = (obj: VendorPayload) => {
        const url = `${apiURL}/${VENDORS}`;
        const body: Record<string, unknown> = { name: obj.name };
        if (obj.code != null && obj.code !== '') body.code = obj.code;
        if (Array.isArray(obj.shipping_rule_ids)) body.shipping_rule_ids = obj.shipping_rule_ids;
        const options = getOptions({ method: 'POST', token, body });
        fetchRequest(url, options, setCreateVendorResponse, setCreateVendorResult);
    };

    const updateVendor = (id: number, obj: Partial<VendorPayload>) => {
        const url = `${apiURL}/${VENDORS}/${id}`;
        const body: Record<string, unknown> = {};
        if (obj.name != null) body.name = obj.name;
        if (obj.code !== undefined) body.code = obj.code;
        if (Array.isArray(obj.shipping_rule_ids)) body.shipping_rule_ids = obj.shipping_rule_ids;
        const options = getOptions({ method: 'PUT', token, body });
        fetchRequest(url, options, setUpdateVendorResponse, setUpdateVendorResult);
    };

    const deleteVendor = (id: number) => {
        const url = `${apiURL}/${VENDORS}/${id}/delete`;
        const options = getOptions({ method: 'DELETE', token });
        fetchRequest(url, options, setDeleteVendorResponse, setDeleteVendorResult);
    };

    const RESPONSES = {
        getVendorsResponse,
        createVendorResponse,
        updateVendorResponse,
        deleteVendorResponse,
    };

    const RESULTS = {
        getVendorsResult,
        createVendorResult,
        updateVendorResult,
        deleteVendorResult,
    };

    const CTAs = {
        getVendors,
        createVendor,
        updateVendor,
        deleteVendor,
    };

    return { RESPONSES, RESULTS, CTAs };
};

export default useVendors;
